<div
  class="category-cell"
  [class.category-cell_selected]="selected"
  [class.category-cell_readonly]="readonly"
  [ngStyle]="{
    'background-image':
      'url(' + (category?.imageURL ?? (category?.imageId | getImageSrc: '' : 'fullSize' : category?.unionId)) + ')',
  }"
  [routerLink]="category?.link"
  [queryParams]="{ unionId: category?.unionId }"
  (click)="click()"
>
  <h1 class="category-cell__title" [class.category-cell__title_light]="withBackground">{{ category?.name }}</h1>

  <tui-badge *ngIf="count > 0" class="category-cell__badge" size="m">{{ count.toString() }}</tui-badge>
</div>
